import React from 'react';
import { Countdown } from './Countdown';
import { CTAButton } from './CTAButton';
import { COST_ROWS } from './salesData';
export function CostSection() {
  return <section className="bg-cream py-16 sm:py-24" data-id="element-58" data-mp="4l80c6k8xbml">
      <div className="mx-auto max-w-3xl px-5" data-id="element-59" data-mp="4jwum178ptsu">
        <h2 className="text-center font-display text-3xl font-black text-ink sm:text-4xl" data-id="element-60" data-mp="3vriv5kynxg5h">
          ⚖️ ¿Cuánto cuesta no tenerlo?
        </h2>

        <div className="mt-10 overflow-x-auto rounded-2xl border border-rose/10 bg-white shadow-sm" data-id="element-61" data-mp="3qthef6oplsx6">
          <p className="px-4 py-2 text-center text-xs text-ink/45 sm:hidden" data-id="element-62" data-mp="3mq1hsacn3skh">← Deslizá para ver la tabla completa →</p>
          <table className="w-full min-w-[480px] border-collapse text-left text-sm" data-id="element-63" data-mp="3hrzzhrn1fxa2">
            <thead data-id="element-64" data-mp="3ctycwwqelftu">
              <tr className="bg-blush/60" data-id="element-65" data-mp="3curezkef3h5n">
                <th className="px-4 py-3 font-semibold text-ink" data-id="element-66" data-mp="1g0wm4ulrk4lt">Sin MegaPack</th>
                <th className="px-4 py-3 font-semibold text-rose-deep" data-id="element-67" data-mp="1b1a6yfmdkead">Costo real</th>
              </tr>
            </thead>
            <tbody data-id="element-68" data-mp="p7bntbvew4j8">
              {COST_ROWS.map((row, i) => <tr key={i} className="border-t border-rose/10" data-id="element-69" data-mp="t96oqf9fkfwh" data-mpi={i}>
                  <td className="px-4 py-3 text-ink/70" data-id="element-70" data-mp="taq4m4r6coxq">{row.without}</td>
                  <td className="px-4 py-3 font-semibold text-ink" data-id="element-71" data-mp="fafej3xovedm">{row.cost}</td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <p className="mt-8 text-center font-display text-xl font-bold italic text-rose-deep sm:text-2xl" data-id="element-72" data-mp="17yb7bxk50m54">
          El próximo domingo puede ser diferente. 💅
        </p>

        <div className="mt-12 rounded-3xl bg-white p-6 text-center shadow-xl shadow-rose/10 ring-1 ring-rose/10 sm:p-10" data-id="element-73" data-mp="1cz8ms2drj22x">
          <p className="text-sm font-bold uppercase tracking-widest text-rose-deep" data-id="element-74" data-mp="137cmcko7ezvj">
            ⏰ El precio cierra en:
          </p>
          <Countdown className="mt-5" data-id="element-75" data-mp="1qvvxd7yn1qrb" />
          <div className="mt-8 border-t border-rose/10 pt-8" data-id="element-76" data-mp="1quub07c69hua">
            <h3 className="font-display text-xl font-black text-ink" data-id="element-77" data-mp="1voozdo2q2kzp">
              📘 MegaPack Estética Digital Pro
            </h3>
            <p className="mt-1 text-sm text-ink/70" data-id="element-78" data-mp="25hjiavco0zb8">6 Tomos + 4 Bonos · Todos los niveles</p>
            <div className="mt-5 flex items-end justify-center gap-3" data-id="element-79" data-mp="20lc8grh5f3o0">
              <span className="text-lg text-ink/40 line-through" data-id="element-80" data-mp="1vk530z2hagki">$49.990</span>
              <span className="font-display text-5xl font-black text-rose-deep" data-id="element-81" data-mp="1rkmii4ekk7i7">$19.990</span>
              <span className="mb-1 text-sm font-semibold text-ink/60" data-id="element-82" data-mp="1ml9xzqb67cis">ARS</span>
            </div>
            <CTAButton className="mt-6 w-full sm:w-auto" data-id="element-83" data-mp="1htjg8z9wlmhc" />
          </div>
        </div>
      </div>
    </section>;
}